import { Stack, Typography } from '@mui/material';
import { InfoTooltip } from 'components/InfoTooltip';
import { getDenseResponsiveFontSize } from 'theme/watchdutyTheme.utils';

type StatHeaderLabelProps = {
  label: string;
  tooltipText?: string;
};

export const StatHeaderLabel = (props: StatHeaderLabelProps): JSX.Element => {
  const { label, tooltipText } = props;

  return (
    <Stack
      direction="row"
      spacing={0.5}
      component="dt"
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 20,
      }}
    >
      <Typography
        variant="subtitle1"
        color="textSecondary"
        sx={{
          textTransform: 'uppercase',
          fontSize: getDenseResponsiveFontSize('0.8rem'),
        }}
      >
        {label}
      </Typography>
      {tooltipText && (
        <InfoTooltip
          title={tooltipText}
          iconSx={{
            width: 14,
            height: 14,
            color: 'text.secondary',
            mt: '-2px !important',
          }}
        />
      )}
    </Stack>
  );
};
